const initialState = 1;

const searchDetailsTaxpayersPaginationReducer = (state = initialState, action) => {
      switch (action.type) {
            case 'SET_SELECTED_DETAILS_TAXPAYERS_PAGE':
                  return action.pageNumber;
            case 'LOGOUT_USER':
                        return 1;                  
            default:
                  break;
      }
      return state;
};

export default searchDetailsTaxpayersPaginationReducer;